import { v4 } from 'uuid';
import {
  BaseAppGoalEntity,
  BaseAppGoalEntityProps,
} from './base-app-goal.entity';

export class SelfInteractionsGoalEntity extends BaseAppGoalEntity {
  static create(
    props: BaseAppGoalEntityProps,
    entityId?: string
  ): BaseAppGoalEntity {
    const id = entityId || v4();
    const entity = new SelfInteractionsGoalEntity({
      id,
      props,
    });
    return entity;
  }
}
